export const formatMessage = ({ title, message, phone, url, email, address }) => {
  const formattedMessageLines = message
    .split('\n')
    .map(line => line.trim())
    .filter(line => line)
    .map(line => `<p>${line}</p>`)
    .join('');

  const contactLines = [
    phone ? `<div>Телефон: <a href="tel:+7${phone}">+7${phone}</a></div>` : '',
    url ? `<div>Сайт: <a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a></div>` : '',
    email ? `<div>Email: <a href="mailto:${email}">${email}</a></div>` : '',
    address ? `<div>Адрес: <a href="https://yandex.ru/maps/?text=${encodeURIComponent(address)}" target="_blank" rel="noopener noreferrer">${address}</a></div>` : ''
  ].filter(Boolean).join('');

  return `
    <div>
      ${title ? `<h3 class='error'>${title}</h3>` : ''}
      ${formattedMessageLines}
      ${contactLines ? `<div>${contactLines}</div>` : ''}
    </div>
  `.replace(/\s+/g, ' ').trim();
};